'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Content, StyledButton, Wrap } from './styles';
import { truncate } from './utils';
export const ExpandableText = ({ content, truncateLength = 100, readMoreText, readLessText }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const toggleTruncate = () => {
        setIsExpanded(!isExpanded);
    };
    const text = isExpanded ? content : truncate(content, truncateLength);
    return (_jsxs(Wrap, { children: [_jsx(Content, { children: text }), truncateLength < content.length ? (_jsx(StyledButton, { onClick: toggleTruncate, "aria-expanded": isExpanded, children: isExpanded ? readLessText : readMoreText })) : null] }));
};
//# sourceMappingURL=ExpandableText.js.map